export enum Role {
    ADMIN = 'ADMIN',
    CLIENT = 'CLIENT',
    COMMERCIAL = 'COMMERCIAL',
    SUPER_COMMERCIAL = 'SUPER_COMMERCIAL'
}

export const RoleLabel = {
    [Role.ADMIN]: "Admin",
    [Role.CLIENT]: "Client",
    [Role.COMMERCIAL]: "Commercial",
    [Role.SUPER_COMMERCIAL]: "Super Commercial"
}